module.exports = __webpack_public_path__ + "495cab2925c23a31c857ef9894e85da9.svg";